var _circle, _circle2, _circle3, _circle4, _circle5, _rect, _rect2, _rect3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgForms1A4B(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 31,
    viewBox: "0 0 27 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 4.72655,
    cy: 15.2637,
    r: 2.02636,
    fill: "#5568FE"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.72655,
    cy: 4.05273,
    r: 2.02636,
    fill: "#5568FE"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.72655,
    cy: 15.2637,
    r: 3.44481,
    stroke: "#5568FE",
    strokeWidth: 1.21582
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.72655,
    cy: 4.05272,
    r: 3.44481,
    stroke: "#5568FE",
    strokeWidth: 1.21582
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.72655,
    cy: 26.206,
    r: 3.44481,
    stroke: "#9EB1D8",
    strokeWidth: 1.21582
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11.6162,
    y: 2.29492,
    width: 14.9951,
    height: 4.05272,
    rx: 2.02636,
    fill: "#9EB1D8"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 11.6162,
    y: 13.2373,
    width: 14.9951,
    height: 4.05272,
    rx: 2.02636,
    fill: "#9EB1D8"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 11.6162,
    y: 24.1796,
    width: 14.9951,
    height: 4.05272,
    rx: 2.02636,
    fill: "#9EB1D8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgForms1A4B);
export default __webpack_public_path__ + "static/media/forms1a4b.4a0b17d9f33ae987ba08e5c6f73534b0.svg";
export { ForwardRef as ReactComponent };